import Vue from 'vue'
import './plugins/axios';
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router';
import store from './store';
import "@/plugins/echarts";
import moment from 'moment';
// import VueCompositionAPI from '@vue/composition-api'

// Vue.use(VueCompositionAPI)
Vue.config.productionTip = false

Vue.prototype.moment = moment;

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
